import AgLoading from './az-loading';

AgLoading.install = function (Vue) {
  Vue.component(AgLoading.name, AgLoading);
};

export default AgLoading;
